var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IngredientsTable',{attrs:{"value":_vm.value,"targetAmount":_vm.totalMassKg,"editable":""}})}
var staticRenderFns = []

export { render, staticRenderFns }